// App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Home from "./pages/Home";
import Work from "./pages/Work/Work";
import GreenPlatter from "./pages/Work/works/GreenPlatter";
import GreenPlatterApp from "./pages/Work/works/GreenPlatterApp";
import HealthandWellnessTracker from "./pages/Work/works/HealthandWellnessTracker";
import Sidebar from "./components/Sidebar";
import "@fortawesome/fontawesome-free/css/all.min.css";

function App() {
  return (
    <Router>
      <div className="md:flex">
        {" "}
        <Sidebar />
        <div className="md:flex-1">
          {" "}
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />

            <Route path="/work" element={<Work />}>
              <Route path="GreenPlatterApp" element={<GreenPlatterApp />} />
              <Route path="GreenPlatter" element={<GreenPlatter />} />
              <Route
                path="HealthandWellnessTracker"
                element={<HealthandWellnessTracker />}
              />
            </Route>
          </Routes>
          <Navbar />
        </div>
      </div>
    </Router>
  );
}

export default App;
